export default {
  data() {
    return {
      active: ''
    };
  },
  methods: {
    //跳转项目包主页
    toProjectHomePage(id) {
      this.$router.push({
        path: "/pojecthomepage",
        query: {
          id: id
        }
      })
    },
    // mouseXxx方法处理图片的缩放
    mouseEnter() {
      this.active = "transform: scale(1.2);";
    },
    mouseLeave() {
      this.active = "transform: scale(1.0);";
    },
    mouseEnter2() {
      this.active = "transform: scale(1.2);";
    },
    mouseLeave2() {
      this.active = "transform: scale(1.2);";
    }
  },
  props: {
    courses: Array,
    name:String,
  },
  mounted() {
    // // console.log("传值",this.name);
  }
};